module.exports = __webpack_public_path__ + "1_0_64/img/google-play-badge.1e91d02c.png";